import { Drawer } from "@mui/material";
import { useState } from "react";
import Header from "./header/header";
import styles from "./main.module.scss";
import Sidebar from "./sidebar/sidebar";
import { Outlet } from "react-router-dom";

interface ComponentProps {
  children?: React.ReactNode;
}
interface Props {
  window?: () => Window;
}

const Main: React.FC<ComponentProps & Props> = ({ children, window }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSidebarToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const closeSidebar = () => setMobileOpen(false);

  return (
    <div>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleSidebarToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", md: "none" },
        }}
      >
        <Sidebar closeSidebar={closeSidebar} />
      </Drawer>

      <div className={styles.layout}>
        <aside>
          <Sidebar closeSidebar={closeSidebar} />
        </aside>

        <div className={styles.content}>
          <Header handleSidebarToggle={handleSidebarToggle} />
          {children ? children : <Outlet />}
        </div>
      </div>
    </div>
  );
};

export default Main;
